import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs-compat';

@Injectable({
  providedIn: 'root'
})
export class UserDetailsService {

  private subject = new BehaviorSubject<any>(null);
  private details: Observable<any> = this.subject.asObservable();

  setDetails(details: any) {
    this.subject.next(details);
  }

  getDetails() {
    return this.details;
  }
}
